// @flow

import { connect } from 'react-redux';
import { withNavigation } from '@react-navigation/compat';
import { compose } from 'redux';
import {
  canBuySelectedRoamingPackageSelector,
  selectedRoamingPackagePriceSelector,
} from '../../../../modules/TopUps/Bundle/selectors';
import RoamLikeHome from './RoamLikeHome';
import type { StateProps, DispatchProps } from './RoamLikeHome';
import { buyRoamingPackage } from '../../../../modules/International/Roaming/actions';
import { fetchRoamingBundles } from '../../../../modules/Dashboard';
import config from '../../../../config';
import {
  selectedRoamingPackageCountryIdSelector,
  selectedRoamingPackageZoneSelector,
} from '../../../../modules/International/Roaming/reducer';
import { getRoamingGroupCountries } from '../../../../lib/country-utils';
import { isExemptedFromTaxSelector } from '../../../../modules/Customer/selectors';
import { isLoadingSelector } from '../../../../modules/LoadingStatus';

const mapStateToProps = (state): StateProps => ({
  price: selectedRoamingPackagePriceSelector(state),
  canBuy: canBuySelectedRoamingPackageSelector(state),
  roamingCountryId: selectedRoamingPackageCountryIdSelector(state),
  countryList: getRoamingGroupCountries(config.iddCountries, selectedRoamingPackageZoneSelector(state)),
  isExemptedFromTax: isExemptedFromTaxSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'topUpConfirmation'),
});

const mapDispatchToProps: DispatchProps = {
  buy: buyRoamingPackage,
  fetchRoamingBundles,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withNavigation)(RoamLikeHome);
